export default __webpack_public_path__ + "static/media/add-contact.a4d553c1.png";